import Vue from 'vue'
import ringsloading from './ringsLoading'

const VRingsLoading = {
    //被绑定元素插入父节点时调用 
    inserted(el, binding) {
        const loadingCo = Vue.extend(ringsloading)
        const loadingComp = new loadingCo().$mount()
        // 组件实例 挂到el元素上
        el.loadingInstance = loadingComp
        // if (binding.value) {
        Vue.nextTick(() => {
            if (binding.value) {
                el.loadingInstance.visible = true;
            }
            el.appendChild(loadingComp.$el)
        })
        // }
    },
    //所在组件的 VNode 更新时调用
    update(el, binding) {
        //当值改变
        // if (binding.value !== binding.oldValue) {
        if (binding.value) { //v-loading true
            el.loadingInstance.visible = true;
            // el.appendChild(el.loadingInstance.$el)
        } else { //v-loading false 删除节点
            el.loadingInstance.visible = false;
            // el.removeChild(el.loadingInstance.$el)
        }

        // }
    }

    // unbind(el, binding) {
    //   el.loadingInstance && el.loadingInstance.$destroy();
    // }
}
export default VRingsLoading


// WEBPACK FOOTER //
// ./src/directives/ringsLoading/index.js